import { zodResolver } from "@hookform/resolvers/zod";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import defaultIcon from "../../../../assets/images/deafult/default-small-image.png";
import ErrorMessage from "../../../../components/ErrorMessage";

const StakeholderAddModal = ({ schema, onCreate }) => {
  const modalCloseIconButton = useRef(null);
  const [imagePreview, setImagePreview] = useState(defaultIcon);
  const [imageTag, setImageTag] = useState("Icon");

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setValue("iconBase64", file);
    setImageTag(file.name);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = (data) => {
    const { titleEn, iconBase64 } = data;

    const formData = new FormData();
    formData.append("titleEn", titleEn);
    formData.append("icon", iconBase64);
    formData.append("iconTag", imageTag);

    onCreate(formData);
    reset();
    modalCloseIconButton.current.click();
  };

  const handleCloseModal = () => {
    reset();
    setImagePreview(defaultIcon);
  };

  return (
    <div className="text-right pb-5 pb-lg-4">
      <button
        type="button"
        className="add-btn"
        data-toggle="modal"
        data-target="#staticBackdrop"
      >
        Add stakeholder +
      </button>
      <div
        className="modal fade"
        id="staticBackdrop"
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Add Stakeholder
              </h5>
              <button
                ref={modalCloseIconButton}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-body bg-light">
                <div
                  className="stakeholder-card mx-auto"
                  style={{ height: "360px" }}
                >
                  <header className="card-header">
                    <div className="image-uploader">
                      <label className="icon-update-btn" htmlFor="uploader">
                        <i className="fa fa-pencil"></i>
                      </label>
                      <input
                        id="uploader"
                        className="d-none"
                        type="file"
                        accept="image/png, image/jpg, image/jpeg, image/webp"
                        {...register("iconBase64", {
                          onChange: handleImageChange,
                        })}
                      />
                    </div>
                    <img src={imagePreview} alt={imageTag} />
                  </header>
                  <ErrorMessage message={errors?.iconBase64?.message} />
                  <div className=" mt-3">
                    <div className="form__div-container w-100 mb-0">
                      <div className="form__div">
                        <input
                          type="text"
                          className="form__input"
                          {...register("titleEn")}
                        />
                        <label htmlFor="" className="form__label">
                          Title
                        </label>
                      </div>
                    </div>
                    <ErrorMessage message={errors?.titleEn?.message} />
                  </div>
                  <div className="card-footer px-0">
                    <button type="submit" className="save-btn w-100">
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StakeholderAddModal;
